<template>
    <jet-form-section @submitted="saveFlexiTraits">
        <template #title>
            Add / Update Personality Flexi Traits
        </template>

        <template #description>
            
        </template>

        <template #form>
            <div class="col-span-6 sm:col-span-4">
                <select v-model="form.country" @change="getFlexiTraits">
                    <option disabled value="">Please select one</option>
                    <option v-for="country in countries" :value="country.country" :key="country.id">
                        {{ country.country }}
                    </option>
                </select>
                <jet-input-error :message="form.errors.country" class="mt-2" />
            </div>

            <div class="col-span-6 sm:col-span-4">
                <p><b>Flexi Traits: </b></p>
                <label class="flex items-center">
                    <jet-checkbox :value="form.inventive" v-model:checked="form.inventive"/>
                    <span class="ml-2">Inventive</span>
                </label>
                <label class="flex items-center">
                    <jet-checkbox :value="form['young at heart']" v-model:checked="form['young at heart']"/>
                    <span class="ml-2">Young At Heart</span>
                </label>
                <label class="flex items-center">
                    <jet-checkbox :value="form.creative" v-model:checked="form.creative"/>
                    <span class="ml-2">Creative</span>
                </label>
                <label class="flex items-center">
                    <jet-checkbox :value="form.energetic" v-model:checked="form.energetic"/>
                    <span class="ml-2">Energetic</span>
                </label>
                <label class="flex items-center">
                    <jet-checkbox :value="form.exciting" v-model:checked="form.exciting"/>
                    <span class="ml-2">Exciting</span>
                </label>
            </div>
        </template>

        <template #actions>
            <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                Saved.
            </jet-action-message>

            <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                Save
            </jet-button>
        </template>
    </jet-form-section>
</template>

<script>
    import JetActionMessage from '@/Jetstream/ActionMessage'
    import JetCheckbox from '@/Jetstream/Checkbox'
    import JetButton from '@/Jetstream/Button'
    import JetFormSection from '@/Jetstream/FormSection'
    import JetInput from '@/Jetstream/Input'
    import JetInputError from '@/Jetstream/InputError'
    import JetLabel from '@/Jetstream/Label'

    export default {
        components: {
            JetActionMessage,
            JetCheckbox,
            JetButton,
            JetFormSection,
            JetInput,
            JetInputError,
            JetLabel,
        },

        props: ['countries'],

        data() {
            return {
                form: this.$inertia.form({
                    country: '',
                    inventive: false,
                    'young at heart': false,
                    creative: false,
                    energetic: false,
                    exciting: false,
                }),
            }
        },

        methods: {
            saveFlexiTraits() {
                this.form.put(route('tov-flexi-traits.update'), {
                    errorBag: 'saveFlexiTraits',
                    preserveScroll: true,
                    onSuccess: () => this.getFlexiTraits(),
                    onError: () => this.getFlexiTraits()
                })
            },
            getFlexiTraits() {
                let country = this.form.country
                axios.get('/api/tov-pt/'+country)
                    .then((res) => {
                        this.form.reset();
                        this.form.country = country;
                        res.data.traits.forEach(element => {
                            this.form[element.toLowerCase()] = true
                        });
                    })
                    .catch((err) => {
                        window.location.reload();
                    })
            }
        },
    }
</script>
